<template lang="">
<div>
<b-navbar toggleable="lg" type="dark" variant="primary" fixed="top">
            <b-navbar-brand href="#" @click="$router.back()">
                <b-icon icon="arrow-left"></b-icon> {{$route.query.desc}}
            </b-navbar-brand>
            <b-navbar-nav class="ml-auto">
 


</b-navbar-nav>
</b-navbar>
<b-row>
    <b-col md="3">
        <b-card>
            <b-tree-view :data="treeData" :contextMenu="false" @nodeSelect="nodeSelect"></b-tree-view>
        </b-card>
    </b-col>

    <b-col>
        <b-card>
            <b-alert variant="success" show> {{selectedNode.id}} - {{selectedNode.name}}</b-alert>

            <b-table :fields="fields" :items="items">
                <template #cell(login)="data">

   <b-icon v-show="data.item.login==1" @click="oncheck(data.item,'login')" size="lg" icon="check2" variant="success" class="border">
   </b-icon>
   <b-icon v-show="data.item.login==0" @click="oncheck(data.item,'login')" size="lg" icon="x" variant="danger" class="border"></b-icon>
</template>

<template #cell(addnew)="data">
   <b-icon v-show="data.item.addnew==1"  @click="oncheck(data.item,'addnew')" size="lg" icon="check2" variant="success" class="border">
   </b-icon>
   <b-icon v-show="data.item.addnew==0" @click="oncheck(data.item,'addnew')" size="lg" icon="x" variant="danger" class="border"></b-icon>
</template>

<template #cell(edit)="data">
   <b-icon v-show="data.item.edit==1" @click="oncheck(data.item,'edit')" size="lg" icon="check2" variant="success" class="border">
   </b-icon>
   <b-icon v-show="data.item.edit==0" @click="oncheck(data.item,'edit')" size="lg" icon="x" variant="danger" class="border"></b-icon>
</template>

<template #cell(del)="data">
   <b-icon v-show="data.item.del==1" @click="oncheck(data.item,'del')" size="lg" icon="check2" variant="success" class="border">
   </b-icon>
   <b-icon v-show="data.item.del==0" @click="oncheck(data.item,'del')" size="lg" icon="x" variant="danger" class="border"></b-icon>
</template>

</b-table>
</b-card>
</b-col>
</b-row>


</div>
</template>

<script>
import axios from "axios";

export default {
    filters: {

    },
    methods: {
        bitvalue($level, $Auth) {

            let $mask = Math.pow(2, $level - 1);

            let $fun = $mask & $Auth;

            return $fun;

        },
        nodeSelect(node, isSelected) {
            //console.log('Node ' + node + ' has been ' + (isSelected ? 'selected' : 'deselected'))
            console.log(node.data.login)
            //   let row = this.treeData.find(element => element.menuid == this.selectedNode.id);
            //console.log(row)
            if (isSelected) {
                this.selectedNode = node.data
                axios
                    .get(
                        this.$store.getters.getBaseUrl +
                        "/getAuth/" + this.selectedNode.id, {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                    )
                    .then((response) => {
                        // JSON responses are automatically parsed.
                        this.items = response.data;
                        //    console.log(  JSON.parse(response.data))
                    })
            } else if (node.data === this.selectedNode) {
                this.selectedNode = null
            }

        },
        oncheck(item, ac) {
            if (ac == 'login') {
                item.login = !item.login
            }
            if (ac == 'addnew') {
                item.addnew = !item.addnew
            }
            if (ac == 'edit') {
                item.edit = !item.edit
            }

            if (ac == 'del') {
                item.del = !item.del
            }


            // let auth=this.bitvalue(item.level_id,item.login)
            //   console.log(this.items.length)
            let auth = 0
            let auth_add = 0
            let auth_edit = 0
            let auth_del = 0
            for (let $i = 0; $i < this.items.length; $i++) {
                //   console.log(this.items[$i].login )
                if (this.items[$i].login == true) {

                    auth = auth + Math.pow(2, $i)
                }

                if (this.items[$i].addnew == true) {

                    auth_add = auth_add + Math.pow(2, $i)
                }

                if (this.items[$i].edit == true) {

                    auth_edit = auth_edit + Math.pow(2, $i)
                }

                if (this.items[$i].del == true) {

                    auth_del = auth_del + Math.pow(2, $i)
                }

            }
            let rp_data = null;

            let postsdata = {
                table: "menus",
                rows: { "login": auth, addnew: auth_add, edit: auth_edit, del: auth_del },
                pkey: "menuid",
                wharevalue: this.selectedNode._id
            };
            axios
                .post(
                    this.$store.getters.getBaseUrl + "/jsonUpdate",
                    postsdata,
                    {
                        headers: {
                            'Authorization': 'Bearer ' + this.user.login_hash
                        }
                    }
                )
                .then((rep) => {
                    rp_data = rep.data;
                    if (rp_data.msg == "Done") {
                        // alert(rp_data.desc);



                    }
                });
            console.log(auth)
        },


    },
    created() {
        let login = localStorage.getItem("Login");
        this.user = JSON.parse(login);

        axios
            .get(
                this.$store.getters.getBaseUrl +
                "/authtree"
            )
            .then((response) => {
                // JSON responses are automatically parsed.
                this.treeData = response.data;
                //    console.log(  JSON.parse(response.data))
            })


    },
    data() {
        return {
            count: 0,
            treeData: [],
            item: "",
            selectedNode: '',
            contextMenuItems: [],
            fields: [
                { label: "ລະຫັດ", key: "level_id" },
                { label: "ລະດັບການໃຊ້ງານ", key: "level_desc" },
                { label: "View", key: "login", isActive: true },
                { label: "Add New", key: "addnew" },
                { label: "Edit", key: "edit" },
                { label: "Delete", key: "del" },


            ],
            items: [],


        }
    },

}
</script>

<style lang="">

</style>